// export interface CustomerNumberStyles {

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { MyAccountPageContext } from "@insite/content-library/Pages/MyAccountPage";
import { AddressesPageContext } from "@insite/content-library/Pages/AddressesPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React from "react";
import { connect } from "react-redux";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { css } from "styled-components";

// }
export interface CustomerNumberStyles {
    headerProps?: TypographyProps;
    textProps?: TypographyProps;
    wrapper?: InjectableCss;
}

export const customerNumberStyles: CustomerNumberStyles = {
    wrapper: { css: css`padding-top: 15px` },
};

const styles = customerNumberStyles;

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    return {
        customerNumber: getBillToState(state, session.billToId).value?.customerNumber,
    };
};

type Props = ReturnType<typeof mapStateToProps>;

const CustomerNumber: React.FC<Props> = ({ customerNumber }) => {

    if (customerNumber) {
        return (
            <StyledWrapper {...styles.wrapper}>
                <Typography variant="h5" {...styles.headerProps}>{translate("Customer Number")}</Typography>
                {/* eslint-disable-next-line spire/avoid-dynamic-translate */}
                <Typography variant="p" {...styles.textProps}>{translate(customerNumber)}</Typography>
            </StyledWrapper>
        );
    }
    else {
        return <></>;
    }
};


const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CustomerNumber),
    definition: {
        group: "Common",
        displayName: "Customer Number Widget",
        allowedContexts: [MyAccountPageContext, AddressesPageContext],
    },
};

export default widgetModule;

